export default __webpack_public_path__ + "static/media/WBTC.e.9e7a5b91.png";